import { Functions } from '../utils/functions';

export const StatusService = {
    discountsAndOffers: (token, location_id, period, start_date, end_date, period_time, view) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/dashboard/' + location_id + '/discountsAndOffers?period='
            + period + '&start_date=' + start_date + '&end_date=' + end_date + '&period_time=' + period_time
            + '&view=' + view, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                }
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    topBoard: (token, location_id, period, start_date, end_date, period_time, view) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/dashboard/' + location_id + '/topBoard?period='
            + period + '&start_date=' + start_date + '&end_date=' + end_date + '&period_time=' + period_time
            + '&view=' + view, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                }
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    discountsAndOffersTotals: (token, location_id, period, start_date, end_date, period_time, view) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/dashboard/' + location_id + '/discountsAndOffersTotals?period='
            + period + '&start_date=' + start_date + '&end_date=' + end_date + '&period_time=' + period_time
            + '&view=' + view, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                }
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    architectureSources: (token, location_id, period, start_date, end_date, period_time, view) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/dashboard/' + location_id + '/architectureSources?period='
            + period + '&start_date=' + start_date + '&end_date=' + end_date + '&period_time=' + period_time
            + '&view=' + view, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                }
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
};